var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMentorright(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    cliipRule: "evenodd",
    d: "M4.45364 6L0.518485 2.06485C0.160505 1.70687 0.160505 1.12647 0.518485 0.768485C0.876466 0.410505 1.45687 0.410505 1.81485 0.768485L6.39818 5.35182C6.75616 5.7098 6.75616 6.2902 6.39818 6.64818L1.81485 11.2315C1.45687 11.5895 0.876466 11.5895 0.518485 11.2315C0.160505 10.8735 0.160505 10.2931 0.518485 9.93515L4.45364 6Z",
    fill: "#44444F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorright);
export default __webpack_public_path__ + "static/media/mentorright.98bc06b8caa542a0da4ce1bd42d0a5f5.svg";
export { ForwardRef as ReactComponent };